import { titreValueMap } from '@app/Modules/titreValueMap';
import { PageConfig } from '../../type';

export const potentielsParrainagesSchema: PageConfig = {
    config: {
        modelName: 'Potentiels Parrainages',
        itemName: 'un potentiel parrainage',
        apiUrl: '/potentiels-parrainages',
        indentifier: 'potentielsParrainagesSchema',
        options: ['filter', 'order', 'updateManyCustom'],
        defaultOrder: { ['raisonSociale']: 'asc' },
    },

    schemas: [
        {
            style: { width: 150 },
            ref: 'clubId',
            title: 'Détails',
            type: 'custom',

            newRedirect: (row) =>
                `/tables/user/potentielsParrainages/${row.id}/details`,
        },
        // Identification fields
        {
            style: { width: 150 },
            ref: 'status',
            title: 'Statut',
            type: 'select',
            valueMap: [
                { value: 'A_traiter', color: 'warning', icon: 'ClockIcon' },
                { value: 'Ne_pas_appeler', color: 'danger', icon: 'XMarkIcon' },
                { value: 'Refus', color: 'danger', icon: 'HandRaisedIcon' },
                { value: 'Rappeler', color: 'primary', icon: 'PhoneIcon' },
                {
                    value: 'Sans_reponse',
                    color: 'neutral',
                    icon: 'ChatBubbleLeftEllipsisIcon',
                },
                {
                    value: 'Doc_envoyee',
                    color: 'success',
                    icon: 'DocumentCheckIcon',
                },
                {
                    value: 'Parrainage',
                    color: 'success',
                    icon: 'CheckIcon',
                },
                {
                    value: 'Archive',
                    color: 'neutral',
                    icon: 'ArchiveBoxIcon',
                },
            ],
        },
        {
            style: { width: 180 },
            ref: 'feuilletId',
            title: 'Feuillet ID',
        },
        {
            style: { width: 100 },
            ref: 'POTENTIEL_MODIFIE',
            title: 'Modifié',
            type: 'bool',
            ban: ['order'],
        },
        {
            style: { width: 120 },
            ref: 'BDD_OK',
            title: 'BDD OK',
            type: 'bool',
            ban: ['order'],
        },
        {
            style: { width: 120 },
            ref: 'Numero_facture',
            title: 'Numero Facture',
            ban: ['filter', 'order'],
        },
        {
            style: { width: 120 },
            ref: 'langue',
            title: 'Langue',
            type: 'select',
            valueMap: [
                { value: 'FR', color: 'blue', icon: 'GlobeAmericasIcon' },
                { value: 'DE', color: 'yellow', icon: 'GlobeAmericasIcon' },
            ],
        },
        {
            style: { width: 140 },
            ref: 'infosInternes',
            title: 'Infos Internes',
            type: 'pargraphe2',
        },

        {
            style: { width: 140 },
            ref: 'raisonSociale',
            title: 'Raison Sociale',
            search: true,
        },
        {
            style: { width: 100 },
            ref: 'titre',
            title: 'Titre',
            type: 'select',
            valueMap: titreValueMap,
        },
        { style: { width: 120 }, ref: 'prenom1', title: 'Prénom 1' },
        { style: { width: 120 }, ref: 'nom1', title: 'Nom 1' },
        { style: { width: 120 }, ref: 'prenom2', title: 'Prénom 2' },
        { style: { width: 120 }, ref: 'nom2', title: 'Nom 2' },

        // Address fields
        { style: { width: 200 }, ref: 'adresse', title: 'Adresse' },
        { style: { width: 100 }, ref: 'cp', title: 'CP' },
        { style: { width: 120 }, ref: 'numeroPostal', title: 'N° Postal' },
        { style: { width: 140 }, ref: 'localite', title: 'Localité' },

        // Contact fields
        { style: { width: 140 }, ref: 'telephone1', title: 'Téléphone 1' },
        { style: { width: 140 }, ref: 'telephone2', title: 'Téléphone 2' },
        { style: { width: 180 }, ref: 'email', title: 'Email' },

        // Business fields
        {
            style: { width: 180 },
            ref: 'raisonSocialePj',
            title: 'Raison Sociale PJ',
        },
        {
            style: { width: 180 },
            ref: 'libelleFacture',
            title: 'Libellé Facture',
        },
        {
            style: { width: 200 },
            ref: 'correspondance',
            title: 'Correspondance',
            type: 'pargraphe2',
        },
        { style: { width: 140 }, ref: 'accordDe', title: 'Accord De' },
        {
            style: { width: 140 },
            ref: 'dateAccord',
            title: 'Date Accord',
            type: 'date',
        },

        // Internal fields

        { style: { width: 140 }, ref: 'publicite', title: 'Publicité' },
        {
            style: { width: 140 },
            ref: 'reconduction',
            title: 'Reconduction',
            type: 'bool',
        },
        {
            style: { width: 140 },
            ref: 'annonceOk',
            title: 'Annonce OK',
            type: 'bool',
        },
        { style: { width: 140 }, ref: 'ca', title: 'CA', type: 'money' },
        { style: { width: 140 }, ref: 'noClub', title: 'N° Club' },
        {
            style: { width: 160 },
            ref: 'mandat/club/nom',
            title: 'Nom du Club',
            ban: ['filter', 'order'],
        },
        {
            style: { width: 200 },
            ref: 'collaborateur/userName',
            title: 'Collaborateur',
        },

        // Process button for approved entries
        {
            style: { width: 120 },
            ref: 'process',
            title: 'Traiter',
            type: 'button',
            button: {
                label: 'Traiter',
                action: 'process',
                icon: 'ArrowRightIcon',
                color: 'primary',
                apiUrl: '/potentiels-parrainages',
            },
        },
    ],
};
